// GB-Link device protocol constants (stock GBLink-Firmware v2.2.7).
// Facts only, documented in Warnster/kizuna-duo docs/81 section 2. No code from GB-Link sources.

export const USB_VENDOR_ID = 0x2fe3;
export const USB_PRODUCT_ID = 0x000a;

// A Raspberry Pi Pico / RP2040 held in BOOTSEL (ROM bootloader): no GB-Link firmware running.
export const RP2_BOOT_VENDOR_ID = 0x2e8a;
export const RP2_BOOT_PRODUCT_ID = 0x0003;

// WebUSB endpoint numbers on interface 0 (direction is implied by transferIn/transferOut).
export const EP_COMMAND = 1; // OUT: commands, IN: 2-byte statuses
export const EP_DATA = 2; // OUT/IN: 64-byte data, IN also carries command replies

export const LINK_FRAME_BYTES = 64;

export const Cmd = {
  SetMode: 0x00,
  Cancel: 0x01,
  GetFirmwareInfo: 0x0f,
  SetModeMaster: 0x10,
  SetModeSlave: 0x11,
  StartHandshake: 0x12,
  ConnectLink: 0x13,
  SetVoltage3V3: 0x40,
} as const;

export const Mode = {
  GbaLink: 0x01,
  WirelessAdapter: 0x07,
} as const;
export type ModeId = (typeof Mode)[keyof typeof Mode];

export const Status = {
  GameboyConnected: 0xff00,
  GameboyDisconnected: 0xff01,
  AwaitMode: 0xff02,
  HandshakeReceived: 0xff03,
  HandshakeFinished: 0xff04,
  LinkConnected: 0xff05,
  LinkReconnecting: 0xff06,
  LinkClosed: 0xff07,
  DeviceReady: 0xff08,
  EmuTradeSessionFinished: 0xff09,
  GBModeActive: 0xff0a,
  GBPrinterModeActive: 0xff0b,
  GBSessionFinished: 0xff0c,
  StatusDebug: 0xffff,
} as const;

const STATUS_NAMES = new Map<number, string>(Object.entries(Status).map(([k, v]) => [v, k]));

export function statusName(code: number): string {
  return STATUS_NAMES.get(code) ?? `Unknown(0x${code.toString(16).padStart(4, "0")})`;
}

export interface FirmwareInfo {
  major: number;
  minor: number;
  patch: number;
}

export function formatVersion(v: FirmwareInfo): string {
  return `${v.major}.${v.minor}.${v.patch}`;
}

export function versionAtLeast(v: FirmwareInfo, major: number, minor: number, patch: number): boolean {
  if (v.major !== major) return v.major > major;
  if (v.minor !== minor) return v.minor > minor;
  return v.patch >= patch;
}

// RFU1 frames (mode 0x07): ASCII magic "RFU1" at the start of a frame.
export function containsRfu1Magic(bytes: Uint8Array): boolean {
  for (let i = 0; i + 3 < bytes.length; i++) {
    if (bytes[i] === 0x52 && bytes[i + 1] === 0x46 && bytes[i + 2] === 0x55 && bytes[i + 3] === 0x31) return true;
  }
  return false;
}
